import { of } from "rxjs"

import { switchMap } from "rxjs/operators"
import { ofType } from "redux-observable"

import * as types from "./actionTypes"
import * as notificationActions from "./actions"

export const showNotification = (action$) =>
    action$.pipe(
        ofType(types.SHOW_NOTIFICATION),
        switchMap(() => of(notificationActions.setNotification(true)))
    )
